var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 80,
    viewBox: "0 0 45 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1907_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 80,
    rx: 4,
    fill: "#EFF3FF",
    fillOpacity: 0.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1907_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67C23.265 67 19.755 66.2913 16.47 64.8738C13.185 63.4563 10.3275 61.5325 7.8975 59.1025C5.4675 56.6725 3.54375 53.815 2.12625 50.53C0.70875 47.245 0 43.735 0 40C0 36.265 0.70875 32.755 2.12625 29.47C3.54375 26.185 5.4675 23.3275 7.8975 20.8975C10.3275 18.4675 13.185 16.5438 16.47 15.1263C19.755 13.7088 23.265 13 27 13C30.735 13 34.245 13.7088 37.53 15.1263C40.815 16.5438 43.6725 18.4675 46.1025 20.8975C48.5325 23.3275 50.4563 26.185 51.8738 29.47C53.2913 32.755 54 36.265 54 40V43.915C54 46.57 53.0888 48.8313 51.2663 50.6988C49.4438 52.5662 47.205 53.5 44.55 53.5C42.975 53.5 41.49 53.1625 40.095 52.4875C38.7 51.8125 37.53 50.845 36.585 49.585C35.28 50.89 33.8063 51.8688 32.1637 52.5213C30.5213 53.1738 28.8 53.5 27 53.5C23.265 53.5 20.0813 52.1838 17.4488 49.5513C14.8163 46.9188 13.5 43.735 13.5 40C13.5 36.265 14.8163 33.0813 17.4488 30.4488C20.0813 27.8163 23.265 26.5 27 26.5C30.735 26.5 33.9188 27.8163 36.5513 30.4488C39.1838 33.0813 40.5 36.265 40.5 40V43.915C40.5 45.085 40.8825 46.075 41.6475 46.885C42.4125 47.695 43.38 48.1 44.55 48.1C45.72 48.1 46.6875 47.695 47.4525 46.885C48.2175 46.075 48.6 45.085 48.6 43.915V40C48.6 33.97 46.5075 28.8625 42.3225 24.6775C38.1375 20.4925 33.03 18.4 27 18.4C20.97 18.4 15.8625 20.4925 11.6775 24.6775C7.4925 28.8625 5.4 33.97 5.4 40C5.4 46.03 7.4925 51.1375 11.6775 55.3225C15.8625 59.5075 20.97 61.6 27 61.6H37.8C38.565 61.6 39.2063 61.8588 39.7238 62.3763C40.2413 62.8938 40.5 63.535 40.5 64.3C40.5 65.065 40.2413 65.7063 39.7238 66.2238C39.2063 66.7413 38.565 67 37.8 67H27ZM27 48.1C29.25 48.1 31.1625 47.3125 32.7375 45.7375C34.3125 44.1625 35.1 42.25 35.1 40C35.1 37.75 34.3125 35.8375 32.7375 34.2625C31.1625 32.6875 29.25 31.9 27 31.9C24.75 31.9 22.8375 32.6875 21.2625 34.2625C19.6875 35.8375 18.9 37.75 18.9 40C18.9 42.25 19.6875 44.1625 21.2625 45.7375C22.8375 47.3125 24.75 48.1 27 48.1Z",
    fill: "#423ED8",
    fillOpacity: 0.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.af44970093bec5d9235d8d488d8c2953.svg";
export { ForwardRef as ReactComponent };